import { render, staticRenderFns } from "./DocumentoNagroSCR.vue?vue&type=template&id=6f594a6a&"
import script from "./DocumentoNagroSCR.vue?vue&type=script&lang=js&"
export * from "./DocumentoNagroSCR.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoNagroSCR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VOverlay,VProgressCircular})
